import { render, staticRenderFns } from "./DashboardSubscriptionsFeed.vue?vue&type=template&id=356655fe&scoped=true"
import script from "./DashboardSubscriptionsFeed.vue?vue&type=script&lang=ts"
export * from "./DashboardSubscriptionsFeed.vue?vue&type=script&lang=ts"
import style0 from "./DashboardSubscriptionsFeed.vue?vue&type=style&index=0&id=356655fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356655fe",
  null
  
)

export default component.exports